import { fetchAuthenticatedJson } from './authenticatedFetch';

export async function fetchAdminHealth() {
  return fetchAuthenticatedJson('/api/admin/health/services');
}